import React, { useState , useEffect, useMemo, useCallback, useRef } from 'react'
import { useAllBook } from 'store/books/selectors';
import { useCurrentOrgPermission } from 'store/organizations/selectors'
import { find } from "lodash"
import { IconButton } from '@mui/material';
import Loading from './Loading';
import {Print} from '@mui/icons-material';
import { PRINT_KEY } from 'utils/config/reference';
import { useExams } from 'store/exams/selectors';
import { usePageTranslations } from 'store/page_translations/selectors';
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Row } from "antd"
import { useIsTab, useMobileDetect } from 'containers/chat/hooks';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    Select
} from '@mui/material';
import styled from "styled-components";
import { map } from "lodash";
import { Close } from '@mui/icons-material';
import color from 'utils/constants/color';
import PrintMessageLoader from 'modules/PrintLoaderWithMassage';
import * as Sentry from '@sentry/react';
import { useAlert } from './UI/alertSakeBar/alertProvider';

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
`;
const Note = styled.span`
    color: ${color.black400};
    display: block;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 16px;
`;
export default function PrintAction({ chapter, pageId, printLoader, handleImagePrint, from ,isDemo , isReviewAccount  , images , pageSrc }) {
    const showAlert = useAlert();
    const orgPermissions = useCurrentOrgPermission();
    const books = useAllBook();
    const book = useMemo(() => find(books, { id: chapter }), [books, chapter])
    const pages =  useMemo(() => book?book.pages:[], [book])
    const print_permission = useMemo(()=>orgPermissions?.print_permission || {},[]) 
    const exams = useExams();
    const { book_pages_translations } = usePageTranslations();
    const examBookIds = useMemo(()=>exams?exams.flatMap(entry => entry.exams.map(exam => `${exam.bookId}`)):[],[exams]);
    const hasPageTranslation = useMemo(
        () => !!book_pages_translations?.[chapter]?.find((p) => p.page == pageId),
        [book_pages_translations, chapter, pageId]
    );
    const pageTranslationEntry = useMemo(
        () => book_pages_translations?.[chapter]?.find((p) => p.page == pageId),
        [book_pages_translations, chapter, pageId]
    );
    const [loader,setLoader]  = useState(false)
    const isTablate = useIsTab();
    const [selectedFromPage, setSelectedFromPage] = useState("");
     const [selectedToPage, setSelectedToPage] = useState("");
    const isMobile = useMobileDetect();
     const [selectableContent, setSelectableContent] = useState([]);
     const [choseModal,setChooseModal] = useState(false);
    const [printDropdownOpen, setPrintDropdownOpen] = useState(false);
    const [printSectionExpanded, setPrintSectionExpanded] = useState(false);
    const keepDropdownOpenRef = useRef(false);
    const generatePDF = async (from_selected, language = 'en') => {
        try {
          const { default: jsPDF } = await import('jspdf');
          const pdf = new jsPDF('p', 'mm','letter');
          setLoader(true);
          let  imageUrls = images || [];
          if(from_selected=='from_selected'){
            const from_index =images.findIndex(k=>k.pageId==selectedFromPage)
            const to_index = images.findIndex(k=>k.pageId==selectedToPage)
            imageUrls = images.slice(from_index,to_index+1).map(k=>k.src);
          }else if(from_selected=='singlePage'){
            if (hasPageTranslation && pageTranslationEntry) {
              imageUrls = [language === 'en' ? pageTranslationEntry.src : pageSrc]
            } else {
              imageUrls = [pageSrc]
            }
          }
          const loadImage = async (url) => {
            try {
              const response = await fetch(url);
              const blob = await response.blob();
              return URL.createObjectURL(blob);
            } catch (error) {
              Sentry.captureException(`240 Error loading image from URL ${url}: ${error}`);
              console.error(`Error loading image from URL ${url}:`, error);
              return null;
            }
          };
    
          const addImagesToPDF = async () => {
            const page_images = await Promise.all(imageUrls.map(async url=>{
                return loadImage(url)
            }))

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            for (let i = 0; i < page_images.length; i++) {
                if (page_images[i]) {
                    if (i > 0) pdf.addPage(); 
                    pdf.addImage(page_images[i], 'JPEG', 0, 0, pageWidth, pageHeight); 
                }
            }
            if(isMobile||isTablate){
                downloadPDF(pdf.output('blob'))
            }else{
                printPDF(pdf.output('blob'));    
            }     
          };
         setLoader(true);
         await addImagesToPDF();
        } catch (error) {
            Sentry.captureException(`241 Error generating PDF: ${error}`);
          console.error(error);
        } finally {
            setTimeout(()=>{
                setChooseModal(false);
                setLoader(false);
            },1000)
        }
      };
    
    const printPDF = (pdfBlob) => {
        if (pdfBlob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = pdfUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
                iframe.contentWindow.print();
                setTimeout(() => {
                    document.body.removeChild(iframe);
                    URL.revokeObjectURL(pdfUrl);
                }, 100000);
            };
        }
    };
       const downloadPDF = (pdfBlob) => {
        if (pdfBlob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = `${chapter}-${pageId}-${Date.now()}pages.pdf`; // Set the filename
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(pdfUrl); // Clean up the object URL
        }
    };
    useEffect(() => {
        if (pageId && Array.isArray(images)) {
            setSelectableContent(images.map((k, i) => ({ ...k, page_dynamic_id: i + 1 })))

            const selectedIndex = images.findIndex((bk) => bk.pageId == pageId);
            if (selectedIndex >= 0) {
                setSelectedFromPage(images[selectedIndex].pageId);
                setSelectedToPage("");
            }
        }
    }, [images, pageId])
    const has_print = useMemo(() => {
        const isBookCompletePrintable = book?.printable;
        if (from === 'ebook') {
            const has_book_permission = print_permission[chapter];
            const is_exam_book = examBookIds.find(k => k == chapter)
            if (has_book_permission) {
                const pageInfo = find(pages, k => k.pageId == pageId);
                return isBookCompletePrintable || (pageInfo && pageInfo.printable);
            } else if (is_exam_book && print_permission["exams"]) {
                const pageInfo = find(pages, k => k.pageId == pageId);
                return isBookCompletePrintable || (pageInfo && pageInfo.printable);
            }
        } else {
            const key = PRINT_KEY[chapter];
            const has_key_permission = print_permission[key];
            if (has_key_permission) {
                const pageInfo = find(pages, k => k.pageId == pageId);
                return isBookCompletePrintable || (pageInfo && pageInfo.printable);
            }
        }
        return false;
    }, [from, book, pages, print_permission, pageId, chapter,examBookIds]);
    const handleOpen = () => {
        setChooseModal(true)
    }
    const onSinglePagePrint = (language = 'en') => {
        if (pageSrc) {
           generatePDF("singlePage", language)
        } else {
            if (handleImagePrint) {
                handleImagePrint()
            }
        }
    }
    const userNav = () => {
        return {
            items: [
                ...(hasPageTranslation
                    ? [{
                        key: 'singlePage',
                        label: (
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                Print this page
                                <DownOutlined
                                    style={{
                                        transition: 'transform 0.3s',
                                        transform: printSectionExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
                                    }}
                                />
                            </span>
                        ),
                        onClick: () => {
                            keepDropdownOpenRef.current = true;
                            setPrintSectionExpanded((prev) => !prev);
                        }
                    }, ...(printSectionExpanded ? [
                        { key: 'singlePageEn', label: <span style={{ paddingLeft: 8 }}>• English</span>, onClick: () => { onSinglePagePrint('en'); setPrintDropdownOpen(false); } },
                        { key: 'singlePageEs', label: <span style={{ paddingLeft: 8 }}>• Spanish</span>, onClick: () => { onSinglePagePrint('es'); setPrintDropdownOpen(false); } }
                    ] : [])]
                    : [{
                        key: 'singlePage',
                        label: 'Print this page',
                        onClick: () => onSinglePagePrint('en')
                    }]),
                ...(from == "ebook" ? [{
                    key: 'multiplePages',
                    label: 'Print Multiple Pages',
                    onClick: () => { handleOpen(); setPrintDropdownOpen(false); }
                }] : []),
                ...(from != "ebook" ? [{
                    key: 'allPages',
                    label: 'Print all pages',
                    onClick: () => { generatePDF(); setPrintDropdownOpen(false); }
                }] : [])
            ]
        };
    };


    const renderItem = useCallback(() => {
        if (images && images.length > 0) {
            const nav = userNav();
            return (
                <Dropdown
                    trigger={['click', 'touch']}
                    disabled={loader || printLoader}
                    className='print-lession-plan'
                    open={printDropdownOpen}
                    onOpenChange={(open) => {
                        if (!open && keepDropdownOpenRef.current) {
                            keepDropdownOpenRef.current = false;
                            return;
                        }
                        setPrintDropdownOpen(open);
                        if (!open) setPrintSectionExpanded(false);
                    }}
                    placement="bottomCenter"
                    dropdownRender={() => (
                        <Menu
                            key={printSectionExpanded ? 'expanded' : 'collapsed'}
                            selectedKeys={[]}
                            items={nav.items}
                            style={{ minWidth: 200 }}
                        />
                    )}
                >
                    <IconButton  onTouchStart={(e) => e.preventDefault()}   onClick={(e) => e.preventDefault()}  aria-label="print" style={{ padding: 0, color: "white" , paddingLeft:2 , paddingRight:2}} >
                        {loader || printLoader ? <Loading size={20} /> : <Print />}
                    </IconButton>
                </Dropdown>
            )
        } else {
            return (<IconButton
                onClick={onSinglePagePrint}
                style={{ padding: 0, color: "white" ,  paddingLeft:2 , paddingRight:2 }}
                aria-label="print"
                disabled={printLoader || loader}
            >
                {printLoader || loader ? <Loading size={20} /> : <Print />}
            </IconButton>)
        }
    }, [printLoader, loader, images, printDropdownOpen, printSectionExpanded]);
   
    const handleFromPageChange = (event) => {
        const selectedPageValue = event.target.value;
        const selectedIndex = selectableContent.findIndex(
            (bk) => bk.pageId == selectedPageValue
        );
        if (selectedIndex >= 0) {
            setSelectedFromPage(selectableContent[selectedIndex].pageId);
            
            if (selectedToPage && selectedToPage > (parseInt(selectedPageValue) + 10)) {
                showAlert(`Maximum 10 pages can be select.`, "error");
                setSelectedToPage(null);
            }
        }
        if (selectableContent[selectedIndex]) {
            setSelectedFromPage(selectableContent[selectedIndex].pageId)
        }
        if (selectableContent[selectedIndex].pageId > selectedToPage) {
            setSelectedToPage(null)
        }
    };

    const handleToPageChange = (event) => {
        const selectedPageValue = event.target.value;
        const selectedIndex = selectableContent.findIndex((bk) => bk.pageId == selectedPageValue);
        if (selectedIndex >= 0) {
            if (parseInt(selectedPageValue) - parseInt(selectedFromPage) > 9) {
                showAlert(`Maximum 10 pages can be select.`, "error");
            } else {
                setSelectedToPage(event.target.value);
            }
        }
    };
    if (!has_print||isDemo||isReviewAccount) return null;
    return (<>
    <PrintMessageLoader aiModal={loader || printLoader} />
    {renderItem()}
        <Modal
            open={choseModal}
            style={{ height: "100%", width: "100%" }}
        >
            <ModalContent>
                <Row style={{ justifyContent: "space-between" }}>
                    <TitleText>Print Multiple Pages.</TitleText>
                    <IconButton
                        onClick={() => setChooseModal(false)}
                        style={{ padding: 0 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea>
                    <LinkArea>
                        <Row
                            gutter={[24, 24]}
                            style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                            className="floatingLabelBG"
                        >
                            <FormControl variant="outlined" style={{ minWidth: 200 }}>
                                <InputLabel id="fromPageLabel">From Page</InputLabel>
                                <Select
                                    labelId="fromPageLabel"
                                    id="fromPage"
                                    value={selectedFromPage}
                                    onChange={handleFromPageChange}
                                    label="From Page"
                                >
                                    {map(selectableContent, (bk, index) => (
                                        <MenuItem key={index} value={bk.pageId}>
                                            {from == 'balcon' ? bk.page_dynamic_id : bk.numberMasked}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Row>

                        {selectedFromPage && (
                            <Row
                                gutter={[24, 24]}
                                style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                                className="floatingLabelBG"
                            >
                                <FormControl variant="outlined" style={{ minWidth: 200 }}>
                                    <InputLabel id="toPageLabel">To Page</InputLabel>
                                    <Select
                                        labelId="toPageLabel"
                                        id="toPage"
                                        value={selectedToPage}
                                        onChange={handleToPageChange}
                                        label="To Page"
                                    >
                                        {map(selectableContent.slice(selectableContent.findIndex(k=>k.pageId==selectedFromPage)), (bk, index) => (
                                            <MenuItem key={index} value={bk.pageId}>
                                                {from == 'balcon' ? bk.page_dynamic_id : bk.numberMasked}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Row>
                        )}

                        <Row  style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                           <Note style={{ marginBottom: 0, color: color.radish100 }}>A maximum of 10 pages can be selected at a time.</Note>
                            <Button
                                fullWidth
                                color="primary"
                                disabled={!selectedFromPage||!selectedToPage || loader || printLoader}
                                variant="contained"
                                startIcon={loader || printLoader ? <Loading size={20} white /> : null}
                                onClick={() =>{
                                    setChooseModal(false);
                                    generatePDF("from_selected");
                                }}
                            >
                              <Print/>  Print
                            </Button>
                        </Row>
                    </LinkArea>
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    </>
    )
}
